export function isOnline() {
  if (typeof navigator === 'undefined') return true;
  return navigator.onLine !== false;
}

export function isNetworkError(error) {
  if (!isOnline()) return true;
  const msg = String(error?.message || error?.details || error || '').toLowerCase();
  const code = String(error?.code || error?.status || error?.name || '').toLowerCase();
  return (
    code === 'failed to fetch'
    || code === 'typeerror'
    || code === '0'
    || msg.includes('failed to fetch')
    || msg.includes('networkerror')
    || msg.includes('network request failed')
    || msg.includes('network error')
    || msg.includes('load failed')
    || msg.includes('offline')
    || msg.includes('err_internet_disconnected')
    || msg.includes('err_network_changed')
    || msg.includes('the internet connection appears to be offline')
    || msg.includes('fetch')
  );
}

export function subscribeNetwork(onChange) {
  if (typeof window === 'undefined') return () => {};

  const emit = () => {
    try {
      onChange(isOnline());
    } catch {
      /* ignore */
    }
  };

  window.addEventListener('online', emit);
  window.addEventListener('offline', emit);
  document.addEventListener('visibilitychange', emit);

  return () => {
    window.removeEventListener('online', emit);
    window.removeEventListener('offline', emit);
    document.removeEventListener('visibilitychange', emit);
  };
}

export const OFFLINE_STATUS_EVENT = 'oxygym-offline-status';

export function notifyOfflineStatus(detail = {}) {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent(OFFLINE_STATUS_EVENT, { detail }));
}
